export default {"src":"/_next/static/media/logo.ecbf8744.svg","height":32,"width":120,"blurWidth":0,"blurHeight":0};